<template>
  <v-col v-if="trollyHasRestrictedItem" cols="12" lg="12" sm="12">
    <v-alert v-if="ageRestrictedMessage != ''"
      type="error"
      class="ma-0"
      outlined
      text
      >
      {{ageRestrictedMessage}}
      <v-divider v-if="ageRestrictedMessage2!=''"
          class="my-2 error"
      ></v-divider>
       <v-row
          align="center"
          no-gutters
           v-if="ageRestrictedMessage2!=''"
        >
          <v-col class="grow">
            {{ageRestrictedMessage2}}
          </v-col>
        </v-row>  
      </v-alert
    >
  </v-col>
</template>

<script>
export default {
  computed: {
    trollyHasRestrictedItem() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return this.$store.getters.retrieveCurrentTrolly.age_restricted_items
            .hasItems;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    ageRestrictedMessage() {
        let message = "";
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
            message = this.$store.getters.retrieveCurrentTrolly.age_restricted_items.message;
        } 
      } 

      return message;
    },
    ageRestrictedMessage2() {
        let message = "";
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
            if(this.$store.getters.retrieveCurrentTrolly.age_restricted_items.message2 ) {
              message = this.$store.getters.retrieveCurrentTrolly.age_restricted_items.message2;
            }
        } 
      } 

      return message;
    },

  },
};
</script>

<style lang="sass" scoped>
</style>